/**
 * "You open often" for app search (core appsearch.ts AS7): how many times this person opened each screen, on this browser only,
 * per business. Never sent anywhere. Kept small (core bumpUsage keeps the 40 most used); a browser that blocks storage just gets
 * the role's usual screens.
 */
import { bumpUsage } from "@logwave/core";

const key = (userId: string, orgId: string) => `cc.search.usage.${userId}.${orgId}`;

export function readUsage(userId: string, orgId: string): Record<string, number> {
  try {
    const v = JSON.parse(localStorage.getItem(key(userId, orgId)) ?? "{}") as unknown;
    return v && typeof v === "object" && !Array.isArray(v) ? (v as Record<string, number>) : {};
  } catch { return {}; }
}

/** One more open of `path` (a screen visited, or a search result picked). */
export function recordUse(userId: string, orgId: string, path: string): void {
  try { localStorage.setItem(key(userId, orgId), JSON.stringify(bumpUsage(readUsage(userId, orgId), path))); } catch { /* storage off: suggestions fall back to the role's usual */ }
}
